import { useEffect } from 'react';

/**
 * Custom hook to debounce the execution of an effect function with a specified delay.
 * Author: Yong Cheng, GfK - An NIQ company
 * @status: Experimental
 *
 * @param {Function} effect - The effect function to be debounced.
 * @param {Array} dependencies - An array of dependencies for the effect function.
 * @param {number} delay - The delay in milliseconds before executing the effect function.
 */
export const useDebouncedEffect = (effect: any, dependencies: any[], delay: number = 700): void => {
  useEffect(() => {
    let cleanup: void | (() => void);
    const handler: NodeJS.Timeout = setTimeout(() => {
      const maybeCleanup = effect();
      if (typeof maybeCleanup === 'function') {
        cleanup = maybeCleanup;
      }
    }, delay);

    return () => {
      clearTimeout(handler);
      if (typeof cleanup === 'function') {
        cleanup();
      }
    };
  }, [...(dependencies || []), delay]);
};
export default useDebouncedEffect;
